// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.berth-dashboard-container {
    padding: 20px;
    background-color: #f9f9f9;
}

.berth-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 15px;
    align-items: center;
}

    .berth-controls input,
    .berth-controls select,
    .berth-controls button {
        padding: 6px 10px;
        font-size: 14px;
    }

.add-berth-btn {
    background-color: #000;
    color: #fff;
    font-weight: bold;
    border: none;
    padding: 6px 12px;
    cursor: pointer;
}

.berth-table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;
    font-size: 14px;
}

    .berth-table th,
    .berth-table td {
        padding: 10px;
        border: 1px solid #ccc;
        text-align: center;
    }

.status.draft {
    color: orange;
    font-weight: bold;
}

.status.submitted {
    color: blue;
    font-weight: bold;
}

.status.cleared {
    color: green;
    font-weight: bold;
}

.action-icon {
    cursor: pointer;
    margin: 0 5px;
    font-size: 18px;
}

    .action-icon.delete {
        color: red;
    }

.pagination-controls {
    margin-top: 15px;
    display: flex;
    gap: 10px;
    align-items: center;
}
.review-section {
    margin-bottom: 30px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 20px;
}

.review-title {
    font-size: 18px;
    color: #0d47a1;
    margin-bottom: 15px;
    font-weight: 600;
}

.review-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 16px;
}

.review-label {
    font-weight: 600;
    color: #333;
}

.review-section {
    background-color: #f5f5f5;
    padding: 25px;
    border-radius: 8px;
    font-family: 'Poppins', sans-serif;
}

.section-title {
    font-weight: 600;
    font-size: 1.2rem;
    color: #444;
    margin-top: 20px;
    margin-bottom: 10px;
}

.grid-3col {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 10px;
    margin-bottom: 10px;
}

.review-section div {
    font-size: 0.95rem;
    color: #333;
}

.action-btn {
    padding: 10px 16px;
    border: none;
    border-radius: 4px;
    color: white;
    cursor: pointer;
    background-color: #1976d2;
}

    .action-btn:hover {
        background-color: #004ba0;
    }

    .action-btn.draft {
        background-color: #6a1b9a;
    }

        .action-btn.draft:hover {
            background-color: #4a148c;
        }

    .action-btn.submit {
        background-color: #2e7d32;
    }

        .action-btn.submit:hover {
            background-color: #1b5e20;
        }
        `, "",{"version":3,"sources":["webpack://./src/pages/demo/PortCall/BerthDashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;IAEI;;;QAGI,iBAAiB;QACjB,eAAe;IACnB;;AAEJ;IACI,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;IAEI;;QAEI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;;AAEJ;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,eAAe;AACnB;;IAEI;QACI,UAAU;IACd;;AAEJ;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;QAEI;YACI,yBAAyB;QAC7B;;IAEJ;QACI,yBAAyB;IAC7B;;QAEI;YACI,yBAAyB;QAC7B","sourcesContent":[".berth-dashboard-container {\n    padding: 20px;\n    background-color: #f9f9f9;\n}\n\n.berth-controls {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 15px;\n    align-items: center;\n}\n\n    .berth-controls input,\n    .berth-controls select,\n    .berth-controls button {\n        padding: 6px 10px;\n        font-size: 14px;\n    }\n\n.add-berth-btn {\n    background-color: #000;\n    color: #fff;\n    font-weight: bold;\n    border: none;\n    padding: 6px 12px;\n    cursor: pointer;\n}\n\n.berth-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: #fff;\n    font-size: 14px;\n}\n\n    .berth-table th,\n    .berth-table td {\n        padding: 10px;\n        border: 1px solid #ccc;\n        text-align: center;\n    }\n\n.status.draft {\n    color: orange;\n    font-weight: bold;\n}\n\n.status.submitted {\n    color: blue;\n    font-weight: bold;\n}\n\n.status.cleared {\n    color: green;\n    font-weight: bold;\n}\n\n.action-icon {\n    cursor: pointer;\n    margin: 0 5px;\n    font-size: 18px;\n}\n\n    .action-icon.delete {\n        color: red;\n    }\n\n.pagination-controls {\n    margin-top: 15px;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n.review-section {\n    margin-bottom: 30px;\n    border-bottom: 1px solid #ccc;\n    padding-bottom: 20px;\n}\n\n.review-title {\n    font-size: 18px;\n    color: #0d47a1;\n    margin-bottom: 15px;\n    font-weight: 600;\n}\n\n.review-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 16px;\n}\n\n.review-label {\n    font-weight: 600;\n    color: #333;\n}\n\n.review-section {\n    background-color: #f5f5f5;\n    padding: 25px;\n    border-radius: 8px;\n    font-family: 'Poppins', sans-serif;\n}\n\n.section-title {\n    font-weight: 600;\n    font-size: 1.2rem;\n    color: #444;\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n\n.grid-3col {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.review-section div {\n    font-size: 0.95rem;\n    color: #333;\n}\n\n.action-btn {\n    padding: 10px 16px;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    cursor: pointer;\n    background-color: #1976d2;\n}\n\n    .action-btn:hover {\n        background-color: #004ba0;\n    }\n\n    .action-btn.draft {\n        background-color: #6a1b9a;\n    }\n\n        .action-btn.draft:hover {\n            background-color: #4a148c;\n        }\n\n    .action-btn.submit {\n        background-color: #2e7d32;\n    }\n\n        .action-btn.submit:hover {\n            background-color: #1b5e20;\n        }\n        "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
